var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2398 16.305C18.0898 16.29 17.9098 16.29 17.7448 16.305C14.1748 16.185 11.3398 13.26 11.3398 9.66C11.3398 5.985 14.3098 3 17.9998 3C21.6748 3 24.6598 5.985 24.6598 9.66C24.6448 13.26 21.8098 16.185 18.2398 16.305Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7381 21.84C7.10812 24.27 7.10812 28.23 10.7381 30.645C14.8631 33.405 21.6281 33.405 25.7531 30.645C29.3831 28.215 29.3831 24.255 25.7531 21.84C21.6431 19.095 14.8781 19.095 10.7381 21.84Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.fd02a8d9464aa90fc9347251bddbc14d.svg";
export { ForwardRef as ReactComponent };